// extracted by mini-css-extract-plugin
export default {"bannerContainer":"QU9Gr","bannerAnchor":"ZUpxn","textContainer":"LW6px","bannerTitle":"x5CMX","closeIcon":"NMKkR"};